import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import MapIcon from '@mui/icons-material/Map'
import SettingsIcon from '@mui/icons-material/Settings'
import SummarizeIcon from '@mui/icons-material/Summarize'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Toolbar from '@mui/material/Toolbar'
import Link from 'next/link'
import { Can } from '../../../../lib/can'

type Props = {
  setToggleOpen: (input?: boolean | undefined) => void
}

const Sidebar = ({ setToggleOpen }: Props) => {
  return (
    <div>
      <Toolbar />
      <Divider />
      <List>
        <Box
          px={2}
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'end',
          }}
        >
          <IconButton onClick={() => setToggleOpen()}>
            <ChevronLeftIcon />
          </IconButton>
        </Box>
        {[
          { label: 'Map', link: '/', icon: <MapIcon /> },
          {
            label: 'Monthly Report',
            link: '/reports',
            icon: <SummarizeIcon />,
          },
        ].map((item, index) => (
          <Link key={index} href={item.link}>
            <ListItem button>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItem>
          </Link>
        ))}
        <Can I="read" a="configuration">
          <Link href="/configuration">
            <ListItem button>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Configuration" />
            </ListItem>
          </Link>
        </Can>
      </List>
    </div>
  )
}

export default Sidebar
